const Main = 'https://juzhenai.srnsjt.com/autoLogin'

export default {
	path: Main,
	outLink: true,
	meta: {
		sideNav: true,
		requiresAuth: false,
		hidden: false,
		title: '文思子牙',
		icon: 'icon-nav-wsi',
	}
}
